module.exports = __webpack_public_path__ + "static/media/mesut-kaya-eOcyhe5-9sQ-unsplash.00ad52c2.jpg";